import React from "react";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import ProtectedRoute from "./components/ProtectedRoute";
import RequirePlatformAdmin from "./components/RequirePlatformAdmin";
import Login from "./pages/Login";
import OpsPage from "./pages/Ops/OpsPage";

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route
          path="/*"
          element={
            <ProtectedRoute>
              <RequirePlatformAdmin>
                <OpsPage />
              </RequirePlatformAdmin>
            </ProtectedRoute>
          }
        />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}
